/**
 * Указываем, какое количество дней будет отображаться в статистики цен
 */
export const COUNT = 90;

export const FETCH_PRICE_CHART = 'PRICE_CHART/FETCH_PRICE_CHART';
